import React from 'react'

function BlogFilters({ categories, selectedCategory, onCategoryChange, t }) {
  return (
    <div className="blog-filters">
      <h3>{t.blog.categories}</h3>
      <div className="filter-buttons">
        {categories.map(category => (
          <button
            key={category.id}
            className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.id)}
          >
            <span className="filter-icon">{category.icon}</span>
            <span className="filter-text">{t.blog[category.name]}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default BlogFilters
